import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { OverlapItems } from 'atoms/ui/OverlapItems';
import { ScarcityAvatar } from 'atoms/ui/ScarcityAvatar';
import { unitMapping } from 'lib/style';

const Avatar = styled(ScarcityAvatar)`
  width: var(--size);
`;

type AvatarProps = {
  slug: string;
  name?: string;
  avatarUrl?: string | null;
  avatar?: ReactNode;
  scarcity?: Rarity;
};

type Props = {
  avatars?: AvatarProps[];
  additionalPlayersCount?: number;
  size?: keyof typeof unitMapping;
};

export const OverlappingAvatars = ({
  avatars = [],
  additionalPlayersCount,
  size = 2.5,
}: Props) => {
  const withAdditionalCount = (additionalPlayersCount || 0) > 0;

  return (
    <Horizontal
      style={{ '--size': unitMapping[size] } as CSSProperties}
      center
      gap={0.5}
    >
      <OverlapItems>
        {avatars.map(avatar => (
          <Avatar key={avatar.slug} {...avatar} />
        ))}
      </OverlapItems>
      {!!withAdditionalCount && (
        <LabelS color="var(--c-nd-500-opaque)" bold>
          +{additionalPlayersCount}
        </LabelS>
      )}
    </Horizontal>
  );
};
